export default __webpack_public_path__ + "static/media/ill-information.cdc61f66.svg";